import { jsx as _jsx } from "react/jsx-runtime";
import { FaCog } from 'react-icons/fa';
import { ToolBarButton } from './ToolBarButton';
export function PreferencesButton(props) {
    return _jsx(ToolBarButton, { id: "preferences-button", icon: _jsx(FaCog, {}), ...props });
}
